import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';
import { OUTCOME_SVG_MAP } from './outcome-svg.data';

@Component({
  selector: 'dojo-outcome-svg',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `<span [innerHTML]="svgMarkup()"></span>`,
  host: { class: 'inline-block' },
})
export class OutcomeSvgComponent {
  readonly svgType = input.required<string>();
  readonly svgMarkup = computed(() => OUTCOME_SVG_MAP[this.svgType()] ?? '');
}
